module.exports = __webpack_public_path__ + "static/media/sketch.3f231165.svg";